import { render, staticRenderFns } from "./GroupInfo.vue?vue&type=template&id=05a2c3d1"
import script from "./GroupInfo.vue?vue&type=script&lang=js"
export * from "./GroupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports